import Vue from 'vue'
import configApp from '@/config'
import router from '@/router'
import store from '@/store'
const moment = require('moment')

let auth = new Vue({
  methods: {
    handleAuthentication (cognito) {
      let beforeExpiration = cognito.authentication.ExpiresIn * 1000 - 600000
      setTimeout(() => { this.createUsuarioRefreshToken() }, beforeExpiration)
      this.storeSession(cognito)
      this.readUsuario(cognito)
    },

    isAcademyAuthenticated () {
      let currentAcademy = JSON.parse(localStorage.getItem('current_academy'))
      let storedAcademy = store.getters.getAcademyData
      if (Object.keys(storedAcademy).length === 0) {
        store.commit('setAcademyData', currentAcademy)
        storedAcademy = store.getters.getAcademyData
      }
      return storedAcademy
    },

    isUserAuthenticated () {
      let fecha = moment().valueOf()
      let expiresAt = localStorage.getItem('expires_at')
      let accessToken = localStorage.getItem('access_token')
      let storedToken = store.getters.getToken
      let user = JSON.parse(localStorage.getItem('user'))
      let actor = JSON.parse(localStorage.getItem('actor'))
      if (storedToken === '' && accessToken !== null && fecha < expiresAt) {
        // TODO: validar que el usuario tenga actor SuperAdmin
        store.commit('setSession', {
          userdata: user,
          token: accessToken
        })
        storedToken = store.getters.getToken
        store.commit('setActorData', actor)
        let beforeExpiration = moment(JSON.parse(expiresAt)).diff(fecha, 'milliseconds') - 600000
        setTimeout(() => { this.createUsuarioRefreshToken() }, beforeExpiration)
      }
      let consistentTokens = storedToken === accessToken
      return storedToken !== '' & accessToken !== null && consistentTokens && fecha < expiresAt
    },

    login () {
      localStorage.setItem('current_url', window.location.pathname)
      router.push({ name: 'userLogin' })
    },

    logout () {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('actor')
        localStorage.removeItem('current_academy')
        localStorage.removeItem('current_url')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('id_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('user')
        store.commit('unsetSession')
        store.commit('unsetAcademyData')
        store.commit('unsetActorData')
        store.commit('unsetUserData')
        this.login()
      })
    },

    readAcademia () {
      this.$services.read('academia', 'readAcademias')
        .then(response => {
          let academias = response.data
          let academiaVidroop = academias.find(academia => academia.id === configApp.vidroopAcademyUUID)
          if (academiaVidroop) {
            localStorage.setItem('current_academy', JSON.stringify(academiaVidroop))
            store.commit('setAcademyData', academiaVidroop)
            // TODO: incorporar redirección a current_url
            // router.push({ name: 'home' })
            router.push('/gestion/productos-de-vidroop')
          } else {
            console.log('Error: el usuario que intenta acceder no pertence a la Academia de Vidroop')
            this.logout()
          }
        })
        .catch(error => {
          console.log(error)
          this.logout()
        })
    },

    readAcademiaUsuarioActores () {
      this.$services.read('academia', 'readAcademiaUsuarioActores', {}, [configApp.vidroopAcademyUUID])
        .then(response => {
          let actorData = response.data.find(actor => actor.tipo === 5 && actor.habilitado)
          if (response.status === 200 && actorData) {
            localStorage.setItem('actor', JSON.stringify(actorData))
            store.commit('setActorData', actorData)
            this.readAcademia()
          } else {
            console.log('Error: el usuario que intenta acceder no pertence a la Academia de Vidroop')
            this.logout()
          }
        })
        .catch(error => {
          console.log(error)
          this.logout()
        })
    },

    readUsuario (cognito) {
      this.$services.read('usuario', 'readUsuario')
        .then(response => {
          if (response.status === 200 && response.data.email === cognito.email) {
            let storedUser = Object.assign({}, store.getters.getUserData)
            storedUser.vidroop_data = Object.assign({}, response.data)
            localStorage.setItem('user', JSON.stringify(storedUser))
            store.commit('setUserData', storedUser)
            this.readAcademiaUsuarioActores()
          } else {
            this.logout()
          }
        })
        .catch(error => {
          console.log(error)
          this.logout()
        })
    },

    createUsuarioRefreshToken () {
      let storedUser = Object.assign({}, store.getters.getUserData)
      let refreshToken = storedUser.authentication.RefreshToken
      this.$services.create('usuario', 'createUsuarioRefreshToken', { refresh_token: refreshToken })
        .then(response => {
          storedUser.authentication.AccessToken = response.data.authentication.AccessToken
          storedUser.authentication.ExpiresIn = response.data.authentication.ExpiresIn
          storedUser.authentication.IdToken = response.data.authentication.IdToken
          storedUser.authentication.TokenType = response.data.authentication.TokenType
          let beforeExpiration = storedUser.authentication.ExpiresIn * 1000 - 600000
          setTimeout(() => { this.createUsuarioRefreshToken() }, beforeExpiration)
          this.storeSession(storedUser)
        })
        .catch(error => {
          console.log(error)
          this.logout()
        })
    },

    storeSession (cognito) {
      let expiresAt = moment().add(cognito.authentication.ExpiresIn * 1000, 'milliseconds').valueOf()
      localStorage.setItem('expires_at', expiresAt)
      localStorage.setItem('access_token', cognito.authentication.AccessToken)
      localStorage.setItem('id_token', cognito.authentication.IdToken)
      localStorage.setItem('refresh_token', cognito.authentication.RefreshToken)
      localStorage.setItem('user', JSON.stringify(cognito))
      store.commit('setSession', {
        userdata: cognito,
        token: cognito.authentication.AccessToken
      })
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$auth = auth
  }
}
